import { Box, Flex, Text, Tooltip } from '@chakra-ui/react';
import {
  getPercentage,
  progressBarColors,
  SegmentProps,
} from '../../../shared/utils';

type Props = {
  data: { [key: string]: number }[];
};

const ProgressBarSegment = ({
  label,
  value,
  color,
  percentage,
  isFirst,
  isLast,
}: SegmentProps) => (
  <Tooltip label={`${label}: ${value}`} hasArrow>
    <Box
      position="relative"
      h="100%"
      w={`${percentage}%`}
      bg={color}
      borderRadius={
        isFirst ? '2px 0 0 2px' : isLast ? '0 2px 2px 0' : undefined
      }
      borderRight={!isLast ? '1px solid white' : undefined}
    >
      {percentage >= 7 && (
        <Box position="absolute" top={'6px'} left={'8px'}>
          <Text
            color="white"
            fontFamily="heading"
            fontSize="sm"
            fontWeight="semibold"
          >
            {value}
          </Text>
        </Box>
      )}
    </Box>
  </Tooltip>
);

const ProgressBar = ({ data }: Props) => {
  const { atRisk, behind, onTrack } = data[0];
  const total = atRisk + behind + onTrack;

  const segments = [
    {
      label: 'At Risk',
      value: atRisk,
      color: progressBarColors.atRisk,
      isFirst: true,
    },
    { label: 'Behind', value: behind, color: progressBarColors.behind },
    {
      label: 'On Track',
      value: onTrack,
      color: progressBarColors.onTrack,
      isLast: true,
    },
  ];

  const displaySegments = segments
    .filter((segment) => segment.value > 0)
    .map((segment, index, filteredArray) => ({
      ...segment,
      isFirst: index === 0,
      isLast: index === filteredArray.length - 1,
    }));

  return (
    <Box>
      <Flex
        w="100%"
        h="32px"
        overflow="hidden"
        bg="text.tertiary"
        position="relative"
      >
        {displaySegments.map((segment, index) => (
          <ProgressBarSegment
            key={index}
            label={segment.label}
            value={segment.value}
            color={segment.color}
            percentage={getPercentage(segment.value, total)}
            isFirst={segment.isFirst}
            isLast={segment.isLast}
          />
        ))}
      </Flex>
    </Box>
  );
};

export default ProgressBar;
